<section>
  <div class="birthday">
    <h1 class="birthday__title">Der Schutz Ihrer Daten ist uns wichtig</h1>
    <h2 class="birthday__subtitle">
      Geben Sie bitte das Geburtsdatum des ersten Kreditnehmers an, um Ihren
      Kreditantrag zu vervollständigen.
    </h2>
    <form class="birthday__form" [formGroup]="form">
      <div class="form__input" [ngClass]="{ inputFocus: inputFocus }">
        <label for="label">Geburtsdatum des ersten Kreditnehmers</label>
        <input
          placeholder="TT.MM.JJJJ"
          maxlength="10"
          id="label"
          #inputElement
          type="text"
          formControlName="birthday"
          (click)="labelMove()"
          (keyup)="onKeyup(inputElement.value)"
        />
        <p *ngIf="correctDate" class="form__error">
          Bitte geben Sie ein korrektes Datum ein.
        </p>
        <p *ngIf="correctUserBdate" class="form__error">
          {{ bdayCheckMessage }}
        </p>
      </div>
      <button
        class="form__submit"
        (click)="sendBday(inputElement.value)"
        [disabled]="correctUserBdate"
      >
        Bestätigen
      </button>
    </form>
  </div>
</section>
